import { Quote, FileText } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export default function SourceChip({ item }) {
  const { t } = useI18n();
  const pageTxt = item.page ? t("chip.page", { n: item.page }) : null;
  const name = item.source_filename || t("chip.source");
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          data-testid={`source-chip-${item.id}`}
          className="inline-flex items-center gap-1.5 px-2 py-1 bg-zinc-800/50 hover:bg-zinc-700/80 border border-zinc-700 rounded-md cursor-pointer transition-colors font-mono-ui text-[11px] text-zinc-300 max-w-full"
        >
          <FileText className="h-3 w-3 shrink-0 text-zinc-500" />
          <span className="truncate max-w-[160px]">{name}</span>
          {pageTxt && <span className="text-zinc-500">· {pageTxt}</span>}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-80 bg-[#0a0a0c] border-zinc-700 text-zinc-200" side="top">
        <div className="flex items-center gap-2 font-mono-ui text-[10px] uppercase tracking-wider text-zinc-500">
          <Quote className="h-3 w-3" /> {t("chip.quoteTitle")}
        </div>
        <p className="mt-2 text-sm leading-relaxed text-zinc-300 border-l-2 border-[#d4af37]/60 pl-3 italic">
          “{item.snippet || "—"}”
        </p>
        <p className="mt-3 font-mono-ui text-[11px] text-zinc-500">
          {name}{pageTxt ? ` · ${pageTxt}` : ""}
        </p>
      </PopoverContent>
    </Popover>
  );
}
